<template>
  <div class="language-section">
    <div
      :class="{
        'font-weight-bold': true,
        'language-card-title': titleCard,
        'language-card-header': true,
      }"
    >
      {{ title }}
      <span v-if="enableToolTip">
        <RsIcon
          v-b-tooltip.hover.right="$utils.decodeHtml(`${toolTipText}`)"
          class="fas"
          icon="question-circle"
        />
      </span>
    </div>
    <div class="pt-1 pr-1 pl-1">
      <RsInfoBlock
        v-if="titleCardMsg"
        :msg="titleCardMsg"
        :is-closable="false"
      />
    </div>
    <div class="language-card-body">
      <RsCheckboxGroup
        :id="`${title}-checkbox`"
        :options="options"
        :selected="selected"
        @change="handleLanguageChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsLanguageSelect',

  props: {
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<ISelectOption[]>,
      default() {
        return [];
      },
    },
    selected: {
      type: Array as PropType<number[]>,
      default() {
        return [];
      },
    },
    titleCard: {
      type: Boolean,
      default: false,
    },
    titleCardMsg: {
      type: String,
      default: '',
    },
    enableToolTip: {
      type: Boolean,
      default: false,
    },
    toolTipText: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleLanguageChange(options: (number|string)[]) {
      this.$emit('on-language-change', options);
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.language-section {
    border: 1px $light-gray solid;
    border-radius: $global-radius;
    background-color: white;
    padding: 0;
    .language-card-header {
      border-bottom: 1px $light-gray solid;
      padding: 0.25rem 1rem;
      .fa-question-circle {
        font-size: 16px;
        color: #7D59E1;;
      }
    }
    .language-card-title {
      background-color: #DFE1F8;
    }
    .language-card-body {
      padding: 1rem 1rem 0 1rem;
      .label {
        padding-right: 1rem !important;
      }
    }
}

</style>
